import { Injectable } from '@angular/core';

// Declare all Metronic and KTUI components
declare var KTToggle: any;
declare var KTDrawer: any;
declare var KTMenu: any;
declare var KTScrollable: any;
declare var KTSticky: any;
declare var KTReparent: any;
declare var KTRotate: any;
declare var KTDropdown: any;
declare var KTModal: any;
declare var KTCollapse: any;
declare var KTDismiss: any;
declare var KTTabs: any;
declare var KTAccordion: any;
declare var KTScrollspy: any;
declare var KTScrollto: any;
declare var KTTooltip: any;
declare var KTStepper: any;
declare var KTThemeSwitch: any;
declare var KTImageInput: any;
declare var KTTogglePassword: any;
declare var KTDataTable: any;
declare var KTDatepicker: any;
declare var KTSelect: any;
declare var KTToast: any;

@Injectable({
  providedIn: 'root'
})
export class MetronicInitService {

  constructor() { }

  init() {
    this.initToggles();
    this.initScrollables();
    this.initDrawers();
    this.initMenus();
    this.initSticky();
    this.initReparent();
    this.initDropdowns();
    this.initModals();
    this.initCollapse();
    this.initDismiss();
    this.initTabs();
    this.initAccordions();
    this.initScrollspy();
    this.initScrollto();
    this.initTooltips();
    this.initSteppers();
    this.initThemeSwitch();
    this.initImageInput();
    this.initTogglePassword();
    this.initDatatables();
    this.initDatepicker();
    this.initSelect();
    this.initToast();
  }

  initDrawers() {
    if (typeof KTDrawer !== 'undefined') {
      KTDrawer.init();
    }
  }

  initMenus() {
    if (typeof KTMenu !== 'undefined') {
      KTMenu.init();
    }
  }

  initDropdowns() {
    if (typeof KTDropdown !== 'undefined') {
      KTDropdown.init();
    }
  }

  initSticky() {
    if (typeof KTSticky !== 'undefined') {
      KTSticky.init();
    }
  }

  initReparent() {
    if (typeof KTReparent !== 'undefined') {
      KTReparent.init();
    }
  }

  initScrollables() {
    if (typeof KTScrollable !== 'undefined') {
      KTScrollable.init();
    }
  }

  initToggles() {
    if (typeof KTToggle !== 'undefined') {
      KTToggle.init();
    }
  }

  initModals() {
    if (typeof KTModal !== 'undefined') {
      KTModal.init();
    }
  }

  initCollapse() {
    if (typeof KTCollapse !== 'undefined') {
      KTCollapse.init();
    }
  }

  initDismiss() {
    if (typeof KTDismiss !== 'undefined') {
      KTDismiss.init();
    }
  }

  initTabs() {
    if (typeof KTTabs !== 'undefined') {
      KTTabs.init();
    }
  }

  initAccordions() {
    if (typeof KTAccordion !== 'undefined') {
      KTAccordion.init();
    }
  }

  initScrollspy() {
    if (typeof KTScrollspy !== 'undefined') {
      KTScrollspy.init();
    }
  }

  initScrollto() {
    if (typeof KTScrollto !== 'undefined') {
      KTScrollto.init();
    }
  }

  initTooltips() {
    if (typeof KTTooltip !== 'undefined') {
      KTTooltip.init();
    }
  }

  initSteppers() {
    if (typeof KTStepper !== 'undefined') {
      KTStepper.init();
    }
  }

  initThemeSwitch() {
    if (typeof KTThemeSwitch !== 'undefined') {
      KTThemeSwitch.init();
    }
  }

  initImageInput() {
    if (typeof KTImageInput !== 'undefined') {
      KTImageInput.init();
    }
  }

  initTogglePassword() {
    if (typeof KTTogglePassword !== 'undefined') {
      KTTogglePassword.init();
    }
  }

  initDatatables() {
    if (typeof KTDataTable !== 'undefined') {
      KTDataTable.init();
    }
  }

  initDatepicker() {
    if (typeof KTDatepicker !== 'undefined') {
      KTDatepicker.init();
    }
  }

  initSelect() {
    if (typeof KTSelect !== 'undefined') {
      KTSelect.init();
    }
  }

  initToast() {
    if (typeof KTToast !== 'undefined') {
      KTToast.init();
    }
  }
}